// machine
import machineSide from "Assets/Maschine/Mirra_1_single_motor_2024-Nov-22_side.png";
import machineSideCut from "Assets/Maschine/Mirra_1_single_motor_2024-Nov-22_side_cut.png";
import machineFront from "Assets/Maschine/Mirra_1_single_motor_2024-Dec-14_front.png";
import machineFrontLeft from "Assets/Maschine/Mirra_1_single_motor_2024-Dec-14_front_left.png";
import machineFrontTop from "Assets/Maschine/Mirra_1_single_motor_2024-Dec-14_front_top.png";
import machineFrontSide from "Assets/Maschine/Mirra_1_single_motor_2024-Nov-22_front_side.png";
import machineBackSide from "Assets/Maschine/Mirra_1_single_motor_2024-Dec-14_back_side.png";
import machineBack from "Assets/Maschine/Mirra_1_single_motor_2024-Nov-22_back.png";
import machineSectionView from "Assets/Maschine/Mirra_1_single_motor_2024-Nov-22_section_view.png";
import machineBackSideTop from "Assets/Maschine/Mirra_1_single_motor_2024-Nov-22_back_side_top.png";
import machineNoCover from "Assets/Maschine/Mirra_1_single_motor_2024-Nov-28_noCover.png";

//parts

import auger from "Assets/Maschine/Parts/auger.png";
import burrs from "Assets/Maschine/Parts/burrs.png";
import piston from "Assets/Maschine/Parts/piston.png";
import portafilter from "Assets/Maschine/Parts/portafilter.png";
import drip_tray from "Assets/Maschine/Parts/drip_tray.png";
import water_bean_tank from "Assets/Maschine/Parts/water_bean_tank.png";

// Collections#
import collection1 from "Assets/Collections/Collection_1.png";
import collection2 from "Assets/Collections/Collection_2.png";
import collection3 from "Assets/Collections/Collection_3.png";

const machineAssets = {
  machineSide: machineSide,
  machineSideCut: machineSideCut,
  machineFront: machineFront,
  machineFrontTop: machineFrontTop,
  machineFrontLeft: machineFrontLeft,
  machineFrontSide: machineFrontSide,
  machineBackSide: machineBackSide,
  machineBack: machineBack,
  machineSectionView: machineSectionView,
  machineBackSideTop: machineBackSideTop,
  machineNoCover: machineNoCover,
};

const machineParts = {
  auger: auger,
  burrs: burrs,
  piston: piston,
  portafilter: portafilter,
  drip_tray: drip_tray,
  water_bean_tank: water_bean_tank,

};

const CollectionAssets = {
  collection1,
  collection2,
  collection3,
};

export { machineAssets, machineParts, CollectionAssets };
